import { createSelector } from '@reduxjs/toolkit'

export const SLICE_NAME = 'theme'

const select = (state: any) => state[SLICE_NAME]

export const getThemeReducer = createSelector(select, reducer => reducer)
